var _defs, _g, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBttnRadioEsculab = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bttn_radio",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-13 {\n        fill: #0077C8;\n        stroke: #0077C8;\n        stroke-width: 2px;\n      }\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        stroke: none;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 7.5,
    cy: 7.5,
    r: 6.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icn_done",
    className: "cls-2",
    d: "M8.005,13.9,5.826,11.72l-.726.726,2.905,2.905,6.225-6.225L13.5,8.4Z",
    transform: "translate(-2.094 -4.306)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBttnRadioEsculab, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bttn_radio_esculab.12970354.svg";
export { ForwardRef as ReactComponent };